import ServerCall from "./ServerCall";
import { UseContextApp } from "../Global/Context/appContext";

const SoporteController = () => {
  const [{ consumoData, user }, dispatch] = UseContextApp();
  const getTicketByCustom = async () => {

    let mes = "";
    let anoMes = "";
    let iniDate = "";
    let documentoIdentidad = "";
    const CURRENT_MONTH = (new Date().getMonth() + 1);
    const CURRENT_YEARS = new Date().getFullYear();
    const CURRENT_DAYS = new Date().getDate();
    let dia = (CURRENT_DAYS.toString().length === 1 ? '0' + CURRENT_DAYS.toString() : CURRENT_DAYS);
    switch (CURRENT_MONTH) {
      case 1:
        mes = "10";
        anoMes = CURRENT_YEARS - 1;
        break;
      case 2:

        mes = "11";
        anoMes = CURRENT_YEARS - 1;
        break;
      case 3:

        mes = "12";
        anoMes = CURRENT_YEARS - 1;
        break;
      default:
        mes = CURRENT_MONTH - 3;
        anoMes = CURRENT_YEARS;
        break;
    }


    if (user?.type === "CI") { documentoIdentidad = user?.id }
    else { documentoIdentidad = user?.type + user?.id }
    iniDate = (anoMes + '-' + mes + '-' + dia);
    var body = new FormData();
    body.append("customField1", `cf_documento_de_identidad:${documentoIdentidad}`);
    body.append(
      "createdTimeRange",
      `${new Date(iniDate).toISOString()},${new Date().toISOString()}`
    );
    const response = await ServerCall.post(
      `/Soporte/GetTicketByCustom`,
      body,
      user.token
    );
    return response;
  };

  const refresh = async (input) => {
      var body = new FormData();
      if (user.type !== "CI") {
        body.append("docIdentidad", user.type + input.cedula);
      } else {
        body.append("docIdentidad", input.cedula);
      }
      const response = await ServerCall.post(
        `/Soporte/Refresh`,
        body,
        user.token
      );
      return response;
  };

  return { refresh, getTicketByCustom };
};

export default SoporteController;
